import { WORD_PACKS } from "../data/word-packs";
import { listCustomPacks } from "../local/customPacks";

// DrawIt's word pool is just plain English strings (see DrawRoom's `start`
// message) — this maps them back to the SAME Fluent 3D image the word uses
// everywhere else in the game, so the word-choice buttons can show a picture
// instead of bare text.
let index: Map<string, string> | null = null;
function ensureIndex(): Map<string, string> {
  if (index) return index;
  index = new Map();
  for (const pack of [...WORD_PACKS, ...listCustomPacks()]) {
    for (const w of pack.words) {
      const key = w.english.trim().toLowerCase();
      if (w.imageUrl && !index.has(key)) index.set(key, w.imageUrl);
    }
  }
  return index;
}

export function wordChoiceImage(english: string): string | null {
  return ensureIndex().get(english.trim().toLowerCase()) ?? null;
}
